
import { RewardsHistory } from "@/components/dashboard/RewardsHistory";
import { NodeStatistics } from "@/components/dashboard/NodeStatistics";
import { RewardsPrognosis } from "@/components/dashboard/RewardsPrognosis";
import { PerformanceTiles } from "@/components/dashboard/PerformanceTiles";
import { EventTimeline } from "@/components/dashboard/EventTimeline";
import { NodeEventHistory } from "@/components/dashboard/NodeEventHistory";
import { NetworkGraphs } from "@/components/dashboard/NetworkGraphs";
import { TopStakers } from "@/components/dashboard/TopStakers";
import { useNodeData } from "@/hooks/useNodeData";
import { useNodeSelection } from "@/contexts/node-selection";

export function NodeDashboard() {
  const { selectedNode } = useNodeSelection();
  const { data, isLoading, error } = useNodeData(selectedNode?.address || null);

  // Show network-wide data when no node is selected
  if (!selectedNode) {
    return (
      <div className="space-y-6">
        <div className="text-center p-4">
          <h2 className="text-xl font-semibold mb-2">Network Overview</h2>
          <p className="text-muted-foreground">Select a node above to view detailed node statistics</p>
        </div>
        <EventTimeline />
        <NetworkGraphs />
      </div>
    );
  }

  if (isLoading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (error) {
    console.error('Dashboard error:', error);
    return <div className="text-center p-4 text-red-500">Error loading dashboard data</div>;
  }

  if (!data) {
    return <div className="text-center p-4">No data available</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col lg:flex-row gap-4">
        <NodeStatistics />
        <RewardsHistory rewardsHistory={data.rewardsHistory} />
      </div>
      <PerformanceTiles address={selectedNode.address} />
      <RewardsPrognosis address={selectedNode.address} />
      <NodeEventHistory address={selectedNode.address} />
      <EventTimeline />
      <div className="flex justify-center">
        <TopStakers />
      </div>
    </div>
  );
}
